import { Trans } from "react-i18next";
import i18next from "i18next";

const SelectRecentPhysicalInjury = ({ fields, setFields, invalidFields, actions }) => {
    let borderStyle = invalidFields && invalidFields.recentphysicalinjury ? '2px solid red' : 'none';
    return (
        <>
            <fieldset>
                <div role="group" className="standby-page-section-row standby-page-section-row-flex standby-page-section-row-flex-spaced standby-page-section-row-flex-align-center standby-form-fieldset">
                    <div className="standby-col standby-col-shrink standby-form-legend">
                        <legend>
                            <h2 className="standby-form-legend-text mt-0">
                                {fields.riskFactorVal}
                            </h2>
                        </legend>
                    </div>
                    <div className="standby-col standby-form-inline-fields pregnancy-select-container">
                        <label htmlFor="rbInjuryYes" id="lblInjuryYes" className="select-child-birth-label1 child-birth-container" style={{border: borderStyle}}>
                            <input
                                type="radio"
                                aria-label={fields.riskFactorVal + " " + i18next.t("findcareoption.Yes")}
                                name="selectRecentPhysicalInjury"
                                id="rbInjuryYes"
                                value="Yes"
                                className="select-child-birth-radio"
                                checked={fields.selectRecentPhysicalInjury === true}
                                onClick={() => {
                                    setFields({ selectRecentPhysicalInjury: true });
                                    if (!document.getElementById("rbInjuryYes").checked 
                                        && !document.getElementById("rbInjuryNo").checked)
                                    {
                                        document.getElementById('lblInjuryYes').style.border = 'borderStyle';
                                        document.getElementById('lblInjuryNo').style.border = 'borderStyle';
                                        document.getElementById('errorPhysicalInjury').style.display = 'block';
                                    }
                                    else
                                    {
                                        invalidFields.recentphysicalinjury = '';
                                        document.getElementById('lblInjuryYes').style.border = '';
                                        document.getElementById('lblInjuryNo').style.border = '';
                                        document.getElementById('errorPhysicalInjury').style.display = 'none';
                                    }
                                }}
                                onChange={() => {}}
                            />
                            <span className="checkmark"></span>
                            <span className="child-option">
                                <Trans i18nKey="findcareoption.Yes">Yes</Trans>
                            </span>
                        </label>
                        <label htmlFor="rbInjuryNo" id="lblInjuryNo" className="select-child-birth-label2 child-birth-container" style={{border: borderStyle}}>
                            <input
                                type="radio"
                                name="selectRecentPhysicalInjury"
                                id="rbInjuryNo"
                                aria-label={fields.riskFactorVal + " " + i18next.t("findcareoption.No")}
                                value="No"
                                className="select-child-birth-radio"
                                checked={fields.selectRecentPhysicalInjury === false}
                                onClick={() => {
                                    setFields({ selectRecentPhysicalInjury: false });
                                    if (!document.getElementById("rbInjuryYes").checked 
                                        && !document.getElementById("rbInjuryNo").checked)
                                    {
                                        document.getElementById('lblInjuryYes').style.border = 'borderStyle';
                                        document.getElementById('lblInjuryNo').style.border = 'borderStyle';
                                        document.getElementById('errorPhysicalInjury').style.display = 'block';
                                    }
                                    else
                                    {
                                        invalidFields.recentphysicalinjury = '';
                                        document.getElementById('lblInjuryYes').style.border = '';
                                        document.getElementById('lblInjuryNo').style.border = '';
                                        document.getElementById('errorPhysicalInjury').style.display = 'none';
                                    }
                                }}
                                onChange={() => {}}
                            />
                            <span className="checkmark"></span>
                            <span className="child-option">
                                <Trans i18nKey="findcareoption.No">No</Trans>
                            </span>
                        </label>
                    </div>
                </div>
            </fieldset>
            <div id="errorPhysicalInjury" className="errormessage-phone" style={{ display: invalidFields.recentphysicalinjury ? "block" : "none" }}>{i18next.t("findcareoption.Start.errorMessages.errorRecentPhysicalInjury")}</div>
        </>
)};

export default SelectRecentPhysicalInjury;